// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SecurityPipelineIcon = createSvgIcon(
  <svg width={48} height={48} fill="none" viewBox="0 0 48 48">
    <g clipPath="url(#security-pipeline_svga)">
      <rect width={48} height={48} fill="#34275F" rx={12} />
      <g filter="url(#security-pipeline_svgb)">
        <mask id="security-pipeline_svgd" fill="#fff">
          <path d="M41.25 28.5h-3.33a14.6 14.6 0 0 0 0-9h3.33z" />
        </mask>
        <path
          fill="url(#security-pipeline_svgc)"
          d="M41.25 28.5h-3.33a14.6 14.6 0 0 0 0-9h3.33z"
        />
        <path
          fill="#4E3E91"
          fillOpacity={0.4}
          d="M41.25 28.5h-3.33a14.6 14.6 0 0 0 0-9h3.33z"
        />
        <path
          fill="#000"
          fillOpacity={0.11}
          d="M41.25 28.5v.19h.19v-.19zm-3.33 0-.18-.06-.08.25h.26zm0-9v-.19h-.26l.08.25zm3.33 0h.19v-.19h-.19zm0 9v-.19h-3.33v.38h3.33zm-3.33 0 .18.06q.7-2.17.71-4.56h-.38q0 2.33-.69 4.44zm.7-4.5h.2q-.02-2.4-.72-4.56l-.18.06-.18.06q.69 2.1.7 4.44zm-.7-4.5v.19h3.33v-.38h-3.33zm3.33 0h-.19v9h.38v-9z"
          mask="url(#security-pipeline_svgd)"
        />
      </g>
      <g filter="url(#security-pipeline_svge)">
        <mask id="security-pipeline_svgg" fill="#fff">
          <path d="M10.08 19.5a14.6 14.6 0 0 0 0 9H7.13v-9z" />
        </mask>
        <path
          fill="url(#security-pipeline_svgf)"
          d="M10.08 19.5a14.6 14.6 0 0 0 0 9H7.13v-9z"
        />
        <path
          fill="#4E3E91"
          fillOpacity={0.4}
          d="M10.08 19.5a14.6 14.6 0 0 0 0 9H7.13v-9z"
        />
        <path
          fill="#000"
          fillOpacity={0.11}
          d="m10.08 19.5.18.06.08-.25h-.26zm0 9v.19h.26l-.08-.25zm-2.95 0h-.2v.19h.2zm0-9v-.19h-.2v.19zm2.95 0-.18-.06A15 15 0 0 0 9.2 24h.37q.01-2.33.7-4.44zm-.7 4.5h-.2q.02 2.4.72 4.56l.18-.06.18-.06q-.69-2.1-.7-4.44zm.7 4.5v-.19H7.13v.38h2.95zm-2.95 0h.18v-9h-.38v9zm0-9v.19h2.95v-.38H7.13z"
          mask="url(#security-pipeline_svgg)"
        />
      </g>
      <g filter="url(#security-pipeline_svgh)">
        <rect
          width={3.75}
          height={12.75}
          x={3}
          y={17.63}
          fill="url(#security-pipeline_svgi)"
          rx={0.38}
        />
        <rect
          width={3.75}
          height={12.75}
          x={3}
          y={17.63}
          fill="#4E3E91"
          fillOpacity={0.2}
          rx={0.38}
        />
        <rect
          width={3.56}
          height={12.56}
          x={3.09}
          y={17.72}
          stroke="#000"
          strokeOpacity={0.11}
          strokeWidth={0.19}
          rx={0.28}
        />
      </g>
      <g filter="url(#security-pipeline_svgj)">
        <rect
          width={3.75}
          height={12.75}
          x={41.25}
          y={17.63}
          fill="url(#security-pipeline_svgk)"
          rx={0.38}
        />
        <rect
          width={3.75}
          height={12.75}
          x={41.25}
          y={17.63}
          fill="#4E3E91"
          fillOpacity={0.2}
          rx={0.38}
        />
        <rect
          width={3.56}
          height={12.56}
          x={41.34}
          y={17.72}
          stroke="#000"
          strokeOpacity={0.11}
          strokeWidth={0.19}
          rx={0.28}
        />
      </g>
      <g filter="url(#security-pipeline_svgl)">
        <circle cx={24} cy={23.98} r={12.38} fill="#34275F" />
        <circle
          cx={24}
          cy={23.98}
          r={12.38}
          fill="url(#security-pipeline_svgm)"
        />
        <circle
          cx={24}
          cy={23.98}
          r={12.38}
          fill="url(#security-pipeline_svgn)"
        />
      </g>
      <g filter="url(#security-pipeline_svgo)">
        <mask id="security-pipeline_svgq" fill="#fff">
          <path d="M24 5.25a18.75 18.75 0 1 1 0 37.5 18.75 18.75 0 0 1 0-37.5m0 7.13a11.63 11.63 0 1 0 0 23.25 11.63 11.63 0 0 0 0-23.26" />
        </mask>
        <g clipPath="url(#security-pipeline_svgp)" data-figma-skip-parse="true">
          <foreignObject
            width={3636.93}
            height={3636.93}
            x={-1818.46}
            y={-1818.46}
            transform="matrix(.00741 .01274 -.01243 .00723 24 24)"
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,#f9f5ff 0deg,#f9f5ff 29.4231deg,#ceadff 67.373deg,#f9f5ff 86.5385deg,#ceadff 173.077deg,#f9f5ff 276.923deg,#ceadff 334.038deg,#f9f5ff 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
        <path
          d="M24 5.25a18.75 18.75 0 1 1 0 37.5 18.75 18.75 0 0 1 0-37.5m0 7.13a11.63 11.63 0 1 0 0 23.25 11.63 11.63 0 0 0 0-23.26"
          data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.97647058963775635,"g":0.96078431606292725,"b":1.0,"a":1.0},"position":0.081730768084526062},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":0.97647058963775635,"g":0.96078431606292725,"b":1.0,"a":1.0},"position":0.24038460850715637},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.48076921701431274},{"color":{"r":0.97647058963775635,"g":0.96078431606292725,"b":1.0,"a":1.0},"position":0.76923078298568726},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.92788463830947876},{"color":{"r":0.97647058963775635,"g":0.96078431606292725,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.97647058963775635,"g":0.96078431606292725,"b":1.0,"a":1.0},"position":0.081730768084526062},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":0.97647058963775635,"g":0.96078431606292725,"b":1.0,"a":1.0},"position":0.24038460850715637},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.48076921701431274},{"color":{"r":0.97647058963775635,"g":0.96078431606292725,"b":1.0,"a":1.0},"position":0.76923078298568726},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.92788463830947876},{"color":{"r":0.97647058963775635,"g":0.96078431606292725,"b":1.0,"a":1.0},"position":1.0}],"transform":{"m00":14.821025848388672,"m01":-24.857683181762695,"m02":29.018327713012695,"m10":25.473630905151367,"m11":14.462656974792480,"m12":4.0318551063537598},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
        />
        <path
          fill="#2A2346"
          d="M24 5.25a18.75 18.75 0 1 1 0 37.5 18.75 18.75 0 0 1 0-37.5m0 7.13a11.63 11.63 0 1 0 0 23.25 11.63 11.63 0 0 0 0-23.26"
          style={{
            mixBlendMode: "saturation",
          }}
        />
        <path
          fill="#000"
          fillOpacity={0.11}
          d="M24 5.25v.38A18.4 18.4 0 0 1 42.38 24h.75A19.13 19.13 0 0 0 24 4.88zM42.75 24h-.37A18.4 18.4 0 0 1 24 42.38v.75A19.13 19.13 0 0 0 43.13 24zM24 42.75v-.37A18.4 18.4 0 0 1 5.63 24h-.75A19.13 19.13 0 0 0 24 43.13zM5.25 24h.38A18.4 18.4 0 0 1 24 5.63v-.75A19.13 19.13 0 0 0 4.88 24zM24 12.38V12a12 12 0 0 0-12 12h.75c0-6.21 5.04-11.25 11.25-11.25zM12.38 24H12a12 12 0 0 0 12 12v-.75A11.25 11.25 0 0 1 12.75 24zM24 35.63V36a12 12 0 0 0 12-12h-.75c0 6.21-5.04 11.25-11.25 11.25zM35.63 24H36a12 12 0 0 0-12-12v.75c6.21 0 11.25 5.04 11.25 11.25z"
          mask="url(#security-pipeline_svgq)"
        />
      </g>
      <g filter="url(#security-pipeline_svgr)">
        <g clipPath="url(#security-pipeline_svgs)" data-figma-skip-parse="true">
          <foreignObject
            width={3022.81}
            height={3022.81}
            x={-1511.41}
            y={-1511.41}
            transform="matrix(.0008 .00141 -.00135 .00076 24 8.63)"
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,#fff 0deg,#ceadff 67.373deg,#fff 133.269deg,#ceadff 315deg,#fff 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
        <rect
          width={3}
          height={3}
          x={22.5}
          y={7.13}
          data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"transform":{"m00":1.5967324972152710,"m01":-2.6952126026153564,"m02":24.549240112304688,"m10":2.8235294818878174,"m11":1.5241680145263672,"m12":6.4511513710021973},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
          rx={1.5}
        />
        <rect
          width={3}
          height={3}
          x={22.5}
          y={7.13}
          fill="#34275F"
          rx={1.5}
          style={{
            mixBlendMode: "color",
          }}
        />
        <rect
          width={2.78}
          height={2.78}
          x={22.61}
          y={7.23}
          stroke="#000"
          strokeOpacity={0.11}
          strokeWidth={0.22}
          rx={1.39}
        />
        <g clipPath="url(#security-pipeline_svgt)" data-figma-skip-parse="true">
          <foreignObject
            width={3022.81}
            height={3022.81}
            x={-1511.41}
            y={-1511.41}
            transform="matrix(.0008 .00141 -.00135 .00076 39 24)"
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,#fff 0deg,#ceadff 67.373deg,#fff 133.269deg,#ceadff 315deg,#fff 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
        <rect
          width={3}
          height={3}
          x={37.5}
          y={22.5}
          data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"transform":{"m00":1.5967324972152710,"m01":-2.6952126026153564,"m02":39.549240112304688,"m10":2.8235294818878174,"m11":1.5241680145263672,"m12":21.826150894165039},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
          rx={1.5}
        />
        <rect
          width={3}
          height={3}
          x={37.5}
          y={22.5}
          fill="#34275F"
          rx={1.5}
          style={{
            mixBlendMode: "color",
          }}
        />
        <rect
          width={2.78}
          height={2.78}
          x={37.61}
          y={22.61}
          stroke="#000"
          strokeOpacity={0.11}
          strokeWidth={0.22}
          rx={1.39}
        />
        <g clipPath="url(#security-pipeline_svgu)" data-figma-skip-parse="true">
          <foreignObject
            width={3022.81}
            height={3022.81}
            x={-1511.41}
            y={-1511.41}
            transform="matrix(.0008 .00141 -.00135 .00076 13.13 34.5)"
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,#fff 0deg,#ceadff 67.373deg,#fff 133.269deg,#ceadff 315deg,#fff 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
        <rect
          width={3}
          height={3}
          x={11.63}
          y={33}
          data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"transform":{"m00":1.5967324972152710,"m01":-2.6952126026153564,"m02":13.674240112304688,"m10":2.8235294818878174,"m11":1.5241680145263672,"m12":32.326152801513672},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
          rx={1.5}
        />
        <rect
          width={3}
          height={3}
          x={11.63}
          y={33}
          fill="#34275F"
          rx={1.5}
          style={{
            mixBlendMode: "color",
          }}
        />
        <rect
          width={2.78}
          height={2.78}
          x={11.73}
          y={33.11}
          stroke="#000"
          strokeOpacity={0.11}
          strokeWidth={0.22}
          rx={1.39}
        />
        <g clipPath="url(#security-pipeline_svgv)" data-figma-skip-parse="true">
          <foreignObject
            width={3022.81}
            height={3022.81}
            x={-1511.41}
            y={-1511.41}
            transform="matrix(.0008 .00141 -.00135 .00076 13.13 13.13)"
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,#fff 0deg,#ceadff 67.373deg,#fff 133.269deg,#ceadff 315deg,#fff 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
        <rect
          width={3}
          height={3}
          x={11.63}
          y={11.63}
          data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"transform":{"m00":1.5967323780059814,"m01":-2.6952123641967773,"m02":13.677474975585938,"m10":2.8235292434692383,"m11":1.5241680145263672,"m12":10.954385757446289},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
          rx={1.5}
        />
        <rect
          width={3}
          height={3}
          x={11.63}
          y={11.63}
          fill="#34275F"
          rx={1.5}
          style={{
            mixBlendMode: "color",
          }}
        />
        <rect
          width={2.78}
          height={2.78}
          x={11.74}
          y={11.74}
          stroke="#000"
          strokeOpacity={0.11}
          strokeWidth={0.22}
          rx={1.39}
        />
        <g clipPath="url(#security-pipeline_svgw)" data-figma-skip-parse="true">
          <foreignObject
            width={3022.81}
            height={3022.81}
            x={-1511.41}
            y={-1511.41}
            transform="matrix(.0008 .00141 -.00135 .00076 24 39)"
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,#fff 0deg,#ceadff 67.373deg,#fff 133.269deg,#ceadff 315deg,#fff 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
        <rect
          width={3}
          height={3}
          x={22.5}
          y={37.5}
          data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"transform":{"m00":1.5967324972152710,"m01":-2.6952126026153564,"m02":24.549240112304688,"m10":2.8235294818878174,"m11":1.5241680145263672,"m12":36.826152801513672},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
          rx={1.5}
        />
        <rect
          width={3}
          height={3}
          x={22.5}
          y={37.5}
          fill="#34275F"
          rx={1.5}
          style={{
            mixBlendMode: "color",
          }}
        />
        <rect
          width={2.78}
          height={2.78}
          x={22.61}
          y={37.61}
          stroke="#000"
          strokeOpacity={0.11}
          strokeWidth={0.22}
          rx={1.39}
        />
        <g clipPath="url(#security-pipeline_svgx)" data-figma-skip-parse="true">
          <foreignObject
            width={3022.81}
            height={3022.81}
            x={-1511.41}
            y={-1511.41}
            transform="matrix(.0008 .00141 -.00135 .00076 9 24)"
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,#fff 0deg,#ceadff 67.373deg,#fff 133.269deg,#ceadff 315deg,#fff 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
        <rect
          width={3}
          height={3}
          x={7.5}
          y={22.5}
          data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"transform":{"m00":1.5967324972152710,"m01":-2.6952126026153564,"m02":9.5492401123046875,"m10":2.8235294818878174,"m11":1.5241680145263672,"m12":21.826150894165039},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
          rx={1.5}
        />
        <rect
          width={3}
          height={3}
          x={7.5}
          y={22.5}
          fill="#34275F"
          rx={1.5}
          style={{
            mixBlendMode: "color",
          }}
        />
        <rect
          width={2.78}
          height={2.78}
          x={7.61}
          y={22.61}
          stroke="#000"
          strokeOpacity={0.11}
          strokeWidth={0.22}
          rx={1.39}
        />
        <g clipPath="url(#security-pipeline_svgy)" data-figma-skip-parse="true">
          <foreignObject
            width={3022.81}
            height={3022.81}
            x={-1511.41}
            y={-1511.41}
            transform="matrix(.0008 .00141 -.00135 .00076 34.87 13.13)"
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,#fff 0deg,#ceadff 67.373deg,#fff 133.269deg,#ceadff 315deg,#fff 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
        <rect
          width={3}
          height={3}
          x={33.37}
          y={11.63}
          data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"transform":{"m00":1.5967324972152710,"m01":-2.6952126026153564,"m02":35.421005249023438,"m10":2.8235294818878174,"m11":1.5241680145263672,"m12":10.954385757446289},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
          rx={1.5}
        />
        <rect
          width={3}
          height={3}
          x={33.37}
          y={11.63}
          fill="#34275F"
          rx={1.5}
          style={{
            mixBlendMode: "color",
          }}
        />
        <rect
          width={2.78}
          height={2.78}
          x={33.48}
          y={11.74}
          stroke="#000"
          strokeOpacity={0.11}
          strokeWidth={0.22}
          rx={1.39}
        />
        <g clipPath="url(#security-pipeline_svgz)" data-figma-skip-parse="true">
          <foreignObject
            width={3022.81}
            height={3022.81}
            x={-1511.41}
            y={-1511.41}
            transform="matrix(.0008 .00141 -.00135 .00076 34.88 34.5)"
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg,#fff 0deg,#ceadff 67.373deg,#fff 133.269deg,#ceadff 315deg,#fff 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
        <rect
          width={3}
          height={3}
          x={33.38}
          y={33}
          data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.18714720010757446},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":0.37019231915473938},{"color":{"r":0.80869567394256592,"g":0.68000000715255737,"b":1.0,"a":1.0},"position":0.8750},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"transform":{"m00":1.5967323780059814,"m01":-2.6952123641967773,"m02":35.424240112304688,"m10":2.8235292434692383,"m11":1.5241680145263672,"m12":32.326152801513672},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
          rx={1.5}
        />
        <rect
          width={3}
          height={3}
          x={33.38}
          y={33}
          fill="#34275F"
          rx={1.5}
          style={{
            mixBlendMode: "color",
          }}
        />
        <rect
          width={2.78}
          height={2.78}
          x={33.48}
          y={33.11}
          stroke="#000"
          strokeOpacity={0.11}
          strokeWidth={0.22}
          rx={1.39}
        />
      </g>
    </g>
    <defs>
      <clipPath id="security-pipeline_svgp">
        <path d="M24 5.25a18.75 18.75 0 1 1 0 37.5 18.75 18.75 0 0 1 0-37.5m0 7.13a11.63 11.63 0 1 0 0 23.25 11.63 11.63 0 0 0 0-23.26" />
      </clipPath>
      <clipPath id="security-pipeline_svgs">
        <rect width={3} height={3} x={22.5} y={7.13} rx={1.5} />
      </clipPath>
      <clipPath id="security-pipeline_svgt">
        <rect width={3} height={3} x={37.5} y={22.5} rx={1.5} />
      </clipPath>
      <clipPath id="security-pipeline_svgu">
        <rect width={3} height={3} x={11.63} y={33} rx={1.5} />
      </clipPath>
      <clipPath id="security-pipeline_svgv">
        <rect width={3} height={3} x={11.63} y={11.63} rx={1.5} />
      </clipPath>
      <clipPath id="security-pipeline_svgw">
        <rect width={3} height={3} x={22.5} y={37.5} rx={1.5} />
      </clipPath>
      <clipPath id="security-pipeline_svgx">
        <rect width={3} height={3} x={7.5} y={22.5} rx={1.5} />
      </clipPath>
      <clipPath id="security-pipeline_svgy">
        <rect width={3} height={3} x={33.37} y={11.63} rx={1.5} />
      </clipPath>
      <clipPath id="security-pipeline_svgz">
        <rect width={3} height={3} x={33.38} y={33} rx={1.5} />
      </clipPath>
      <clipPath id="security-pipeline_svga">
        <path fill="#fff" d="M0 0h48v48H0z" />
      </clipPath>
      <filter
        id="security-pipeline_svgb"
        width={10.08}
        height={25.5}
        x={34.54}
        y={18.75}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.38} />
        <feGaussianBlur stdDeviation={0.56} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.88} />
        <feGaussianBlur stdDeviation={0.94} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0" />
        <feBlend
          in2="effect1_dropShadow_3035_3144"
          result="effect2_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4.5} />
        <feGaussianBlur stdDeviation={1.31} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          in2="effect2_dropShadow_3035_3144"
          result="effect3_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={7.88} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          in2="effect3_dropShadow_3035_3144"
          result="effect4_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={12.38} />
        <feGaussianBlur stdDeviation={1.69} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
        <feBlend
          in2="effect4_dropShadow_3035_3144"
          result="effect5_dropShadow_3035_3144"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect5_dropShadow_3035_3144"
          result="shape"
        />
      </filter>
      <filter
        id="security-pipeline_svge"
        width={9.71}
        height={25.5}
        x={3.75}
        y={18.75}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.38} />
        <feGaussianBlur stdDeviation={0.56} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.88} />
        <feGaussianBlur stdDeviation={0.94} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0" />
        <feBlend
          in2="effect1_dropShadow_3035_3144"
          result="effect2_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4.5} />
        <feGaussianBlur stdDeviation={1.31} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          in2="effect2_dropShadow_3035_3144"
          result="effect3_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={7.88} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          in2="effect3_dropShadow_3035_3144"
          result="effect4_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={12.38} />
        <feGaussianBlur stdDeviation={1.69} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
        <feBlend
          in2="effect4_dropShadow_3035_3144"
          result="effect5_dropShadow_3035_3144"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect5_dropShadow_3035_3144"
          result="shape"
        />
      </filter>
      <filter
        id="security-pipeline_svgh"
        width={10.5}
        height={29.25}
        x={-0.38}
        y={16.88}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.38} />
        <feGaussianBlur stdDeviation={0.56} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.88} />
        <feGaussianBlur stdDeviation={0.94} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0" />
        <feBlend
          in2="effect1_dropShadow_3035_3144"
          result="effect2_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4.5} />
        <feGaussianBlur stdDeviation={1.31} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          in2="effect2_dropShadow_3035_3144"
          result="effect3_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={7.88} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          in2="effect3_dropShadow_3035_3144"
          result="effect4_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={12.38} />
        <feGaussianBlur stdDeviation={1.69} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
        <feBlend
          in2="effect4_dropShadow_3035_3144"
          result="effect5_dropShadow_3035_3144"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect5_dropShadow_3035_3144"
          result="shape"
        />
      </filter>
      <filter
        id="security-pipeline_svgj"
        width={10.5}
        height={29.25}
        x={37.88}
        y={16.88}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.38} />
        <feGaussianBlur stdDeviation={0.56} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.88} />
        <feGaussianBlur stdDeviation={0.94} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0" />
        <feBlend
          in2="effect1_dropShadow_3035_3144"
          result="effect2_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4.5} />
        <feGaussianBlur stdDeviation={1.31} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          in2="effect2_dropShadow_3035_3144"
          result="effect3_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={7.88} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          in2="effect3_dropShadow_3035_3144"
          result="effect4_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={12.38} />
        <feGaussianBlur stdDeviation={1.69} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
        <feBlend
          in2="effect4_dropShadow_3035_3144"
          result="effect5_dropShadow_3035_3144"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect5_dropShadow_3035_3144"
          result="shape"
        />
      </filter>
      <filter
        id="security-pipeline_svgl"
        width={24.75}
        height={26.25}
        x={11.63}
        y={11.61}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.5} />
        <feGaussianBlur stdDeviation={2.13} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.85 0" />
        <feBlend
          in2="shape"
          mode="plus-darker"
          result="effect1_innerShadow_3035_3144"
        />
        <feTurbulence
          baseFrequency="5 5"
          numOctaves={3}
          result="noise"
          seed={6640}
          stitchTiles="stitch"
          type="fractalNoise"
        />
        <feColorMatrix in="noise" result="alphaNoise" type="luminanceToAlpha" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            tableValues="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
            type="discrete"
          />
        </feComponentTransfer>
        <feComposite
          in="coloredNoise1"
          in2="effect1_innerShadow_3035_3144"
          operator="in"
          result="noise1Clipped"
        />
        <feFlood floodColor="#FFF" result="color1Flood" />
        <feComposite
          in="color1Flood"
          in2="noise1Clipped"
          operator="in"
          result="color1"
        />
        <feMerge result="effect2_noise_3035_3144">
          <feMergeNode in="effect1_innerShadow_3035_3144" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="security-pipeline_svgo"
        width={44.25}
        height={54}
        x={1.88}
        y={4.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.38} />
        <feGaussianBlur stdDeviation={0.56} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.88} />
        <feGaussianBlur stdDeviation={0.94} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.34 0" />
        <feBlend
          in2="effect1_dropShadow_3035_3144"
          result="effect2_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4.5} />
        <feGaussianBlur stdDeviation={1.31} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          in2="effect2_dropShadow_3035_3144"
          result="effect3_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={7.88} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          in2="effect3_dropShadow_3035_3144"
          result="effect4_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={12.38} />
        <feGaussianBlur stdDeviation={1.69} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
        <feBlend
          in2="effect4_dropShadow_3035_3144"
          result="effect5_dropShadow_3035_3144"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect5_dropShadow_3035_3144"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-0.19} dy={-0.19} />
        <feGaussianBlur stdDeviation={0.19} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.42 0" />
        <feBlend
          in2="shape"
          mode="plus-darker"
          result="effect6_innerShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.19} dy={0.19} />
        <feGaussianBlur stdDeviation={0.38} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0" />
        <feBlend
          in2="effect6_innerShadow_3035_3144"
          mode="plus-lighter"
          result="effect7_innerShadow_3035_3144"
        />
      </filter>
      <filter
        id="security-pipeline_svgr"
        width={35.75}
        height={37.75}
        x={6.13}
        y={6.13}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix values="0 0 0 0 0.133333 0 0 0 0 0.109804 0 0 0 0 0.207843 0 0 0 0.85 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix values="0 0 0 0 0.133333 0 0 0 0 0.109804 0 0 0 0 0.207843 0 0 0 0.5 0" />
        <feBlend
          in2="effect1_dropShadow_3035_3144"
          result="effect2_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix values="0 0 0 0 0.133333 0 0 0 0 0.109804 0 0 0 0 0.207843 0 0 0 0.15 0" />
        <feBlend
          in2="effect2_dropShadow_3035_3144"
          result="effect3_dropShadow_3035_3144"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix values="0 0 0 0 0.133333 0 0 0 0 0.109804 0 0 0 0 0.207843 0 0 0 0.02 0" />
        <feBlend
          in2="effect3_dropShadow_3035_3144"
          result="effect4_dropShadow_3035_3144"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect4_dropShadow_3035_3144"
          result="shape"
        />
      </filter>
      <linearGradient
        id="security-pipeline_svgc"
        x1={38.86}
        x2={38.86}
        y1={20.16}
        y2={28.24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9F5FF" />
        <stop offset={0.19} stopColor="#CEADFF" />
        <stop offset={0.37} stopColor="#F9F5FF" />
        <stop offset={0.88} stopColor="#CEADFF" />
        <stop offset={1} stopColor="#F9F5FF" />
      </linearGradient>
      <linearGradient
        id="security-pipeline_svgf"
        x1={7.96}
        x2={7.96}
        y1={20.16}
        y2={28.24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9F5FF" />
        <stop offset={0.19} stopColor="#CEADFF" />
        <stop offset={0.37} stopColor="#F9F5FF" />
        <stop offset={0.88} stopColor="#CEADFF" />
        <stop offset={1} stopColor="#F9F5FF" />
      </linearGradient>
      <linearGradient
        id="security-pipeline_svgi"
        x1={4.05}
        x2={4.05}
        y1={18.56}
        y2={30}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9F5FF" />
        <stop offset={0.19} stopColor="#CEADFF" />
        <stop offset={0.37} stopColor="#F9F5FF" />
        <stop offset={0.88} stopColor="#CEADFF" />
        <stop offset={1} stopColor="#F9F5FF" />
      </linearGradient>
      <linearGradient
        id="security-pipeline_svgk"
        x1={42.3}
        x2={42.3}
        y1={18.56}
        y2={30}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9F5FF" />
        <stop offset={0.19} stopColor="#CEADFF" />
        <stop offset={0.37} stopColor="#F9F5FF" />
        <stop offset={0.88} stopColor="#CEADFF" />
        <stop offset={1} stopColor="#F9F5FF" />
      </linearGradient>
      <radialGradient
        id="security-pipeline_svgm"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(146.94 4.2 18.09)scale(13.4233)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#84D3CE" />
        <stop offset={1} stopColor="#84D3CE" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="security-pipeline_svgn"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-168.26 16.01 7.95)scale(14.0444)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#9147FF" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>,
  "SecurityPipeline",
);
export default SecurityPipelineIcon;
